module.exports = __webpack_public_path__ + "media/images/thumb_yamori_link-f6991dc0fb9eb43f6c056d0090c9cf2d.jpg";